import { DictionaryIrzActivityAutocomplete } from '../../models';
import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';

export function useIrzActivities() {
  return useAutocompleteSource<DictionaryIrzActivityAutocomplete>({
    url: EvidenceAPI.DICTIONARY_IRZ_ACTIVITIES + '/autocomplete',
  });
}
